var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgSaveButton = function SvgSaveButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.217 17.61a1.853 1.853 0 001.905-.052l3.683-2.303a.375.375 0 01.397 0l3.683 2.303a1.875 1.875 0 002.865-1.59V2.25A2.25 2.25 0 0011.5 0h-9A2.25 2.25 0 00.25 2.25v13.717a1.852 1.852 0 00.967 1.643zM1.75 2.25a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v13.717a.376.376 0 01-.57.315L7.997 13.98a1.883 1.883 0 00-1.987 0l-3.69 2.31a.374.374 0 01-.57-.322V2.25z",
    fill: "#fff"
  })));
};

export default SvgSaveButton;